import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    motif: 'blackTopic', //主题
    user: null, //登录用户
    distribution: null, //分销信息
    weixinLoginToken: null, //微信授权信息
    token:'',   // token
    loginToken:'',   // loginToken
    currentRoute: null,  // 存储当前路由的状态
    historyChatList: null,  // 记录历史
    bounceLodin: false,
    bounceAboutUs: false, // 关于我的弹窗开关
    isWidth: false, // 左侧窗口是否折叠
    eventSource: null, // 长链接
    eventSourceUrl: false, // 长链接存在时跳转链接
    topTitleObj: {}, // head头部返回路由
    isMobileMine: false, // 移动端的我的页面
  },
  mutations: {
    set_user(state, data) {
      this.state.user = data;
    },
    setMotif(state, data) {
      this.state.motif = data;
    },
    setToken(state, data) {
      this.state.token = data
    },
    setLoginToken(state, data) {
      this.state.loginToken = data
    },
    setDistribution(state, data) {
      this.state.distribution = data
    },
    setWeixinLoginToken(state, data) {
      this.state.weixinLoginToken = data
    },
    sethistoryChatList(state, data) {
      this.state.historyChatList = data
    },
    setBounceLodin(state, data) {
      this.state.bounceLodin = data
    },
    setBounceAboutUs(state, data) {
      this.state.bounceAboutUs = data
    },
    setIsWidth(state, data) {
      this.state.isWidth = data
    },
    setEventSource(state, data) {
      this.state.eventSource = data
    },
    setEventSourceUrl(state, data) {
      this.state.eventSourceUrl = data
    },
    setTopTitleObj(state, data) {
      this.state.topTitleObj = data
    },
    setIsMobileMine(state, data) {
      this.state.isMobileMine = data
    },
    setCurrentRoute(state, data) {
      state.currentRoute = data  // 更新当前路由的状态
    },
  },
  actions: {

  },
})



// WEBPACK FOOTER //
// ./src/store.js